import { NgModule } from '@angular/core';
import { SharedModule } from './shared.module';
import { StandaloneModule } from './standalone.module';
import { IpsComponent } from '../components/ehr/ips/ips.component';

@NgModule({
  declarations: [IpsComponent],
  imports: [SharedModule, StandaloneModule],
  exports: [IpsComponent],
})
export class IpsModule {}
